import React from "react";
import { connect } from "react-redux";
import { ADMIN } from "MODULES/users/constants";

export default function wire(roles, prop, Component) {
  const Connected = connect(state => {
    const userRole = state.session.getIn(["user", "role"]);

    return { [prop]: [ADMIN].concat(roles).includes(userRole) };
  })(Component);

  return ProtectedComponent => props => (
    <Connected>
      <ProtectedComponent {...props} />
    </Connected>
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/authorization/wire.jsx